import { render, staticRenderFns } from "./FileSourceTypeSpan.vue?vue&type=template&id=257d6087&scoped=true"
import script from "./FileSourceTypeSpan.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileSourceTypeSpan.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FileSourceTypeSpan.vue?vue&type=style&index=0&id=257d6087&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257d6087",
  null
  
)

export default component.exports